export default "__VITE_ASSET__CQYVw$IX__"